import { __experimentalText as WCText } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import { __, sprintf } from '@wordpress/i18n';
import { humanTimeDiff } from '@wordpress/date';
import { store as editorStore } from '../../store';

export default function PostLastEditedPanel() {
	const modified = useSelect(
		( select ) =>
			select( editorStore ).getEditedPostAttribute( 'modified' ),
		[]
	);
	if ( ! modified ) {
		return null;
	}
	return (
		<div className="editor-post-last-edited-panel">
			<WCText>
				{ sprintf(
					// translators: %s: Human-readable time difference, e.g. "2 days ago".
					__( 'Last edited %s.' ),
					humanTimeDiff( modified )
				) }
			</WCText>
		</div>
	);
}
